import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {ForgetPasswordComponent} from './forget-password.component';

const routes: Routes = [{
    path: 'forget-password', component: ForgetPasswordComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ForgetPasswordRoutingModule { }
